"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerPortalServiceImpl = void 0;
var rxjs_1 = require("rxjs");
var core_1 = require("@athena-portal/core");
var operators_1 = require("rxjs/operators");
var Types_1 = require("../../Types");
var model_1 = require("../../model");
var Cache_1 = require("../../decorators/Cache");
var EnumPolicyFilter_1 = require("./EnumPolicyFilter");
var __1 = require("../..");
/**
 * Rest implementation of the example service
 */
var CustomerPortalServiceImpl = exports.CustomerPortalServiceImpl = /** @class */ (function (_super) {
    __extends(CustomerPortalServiceImpl, _super);
    function CustomerPortalServiceImpl(configuration, notificationService) {
        var _this_1 = _super.call(this) || this;
        _this_1.configuration = configuration;
        _this_1.notificationService = notificationService;
        return _this_1;
    }
    CustomerPortalServiceImpl.prototype.getProfile = function () {
        return this.doRequest("/profile");
    };
    CustomerPortalServiceImpl.prototype.getPolicies = function (product, filter, onlyCurrentPeriodPolicyVersions) {
        if (onlyCurrentPeriodPolicyVersions === void 0) { onlyCurrentPeriodPolicyVersions = false; }
        var searchParams = new URLSearchParams();
        if (product) {
            searchParams.append("product", product);
        }
        if (filter) {
            searchParams.append("filter", EnumPolicyFilter_1.EnumPolicyFilter[filter]);
        }
        searchParams.append("onlyCurrentPeriodPolicyVersions", onlyCurrentPeriodPolicyVersions.toString());
        return this.doRequest("/flow-policies?".concat(searchParams.toString()), "GET");
    };
    CustomerPortalServiceImpl.prototype.getExpiredPolicies = function (product) {
        var searchParams = new URLSearchParams();
        if (product) {
            searchParams.append("product", product);
        }
        return this.doRequest("/flow-policies/expired?".concat(searchParams.toString()), "GET");
    };
    CustomerPortalServiceImpl.prototype.getMinOrMaxFutureMtaDate = function () {
        return this.doRequest("/flow-policies/get-min-or-max-future-mta-date", "GET");
    };
    CustomerPortalServiceImpl.prototype.mtaIsPresentForMultiplePolicies = function () {
        return this.doRequest("/flow-policies/is-mta-preset-for-multiple-policies", "GET");
    };
    CustomerPortalServiceImpl.prototype.accountHasPolicyWith24hOldMTA = function () {
        return this.doRequest('/flow-policies/account-has-policy-with-24-h-old-mta', "GET");
    };
    CustomerPortalServiceImpl.prototype.policyHas24hOldMTA = function (policyNumber) {
        var searchParams = new URLSearchParams();
        searchParams.append("policyNumber", policyNumber);
        return this.doRequest("/flow-policies/policy-has-24-h-old-mta?".concat(searchParams.toString()));
    };
    CustomerPortalServiceImpl.prototype.getFutureMtaCount = function () {
        return this.doRequest("/flow-policies/future-mta-count", "GET");
    };
    CustomerPortalServiceImpl.prototype.getPoliciesByPolicyVersionId = function (policyVersionId) {
        return this.doRequest("/policyVersions/".concat(policyVersionId));
    };
    CustomerPortalServiceImpl.prototype.getPolicy = function (policyNumber) {
        return this.doRequest("/policies/".concat(policyNumber));
    };
    CustomerPortalServiceImpl.prototype.getUserPoliciesWithLatestVersions = function () {
        return this.getPolicies();
    };
    CustomerPortalServiceImpl.prototype.isAllianzPromotion = function () {
        return this.doRequest("/flow-policies/is-allianz-promotion", "GET");
    };
    CustomerPortalServiceImpl.prototype.getAllDocuments = function () {
        return this.doRequest("/documents", "GET");
    };
    CustomerPortalServiceImpl.prototype.getPolicyDocuments = function (policyNumber) {
        return this.doRequest("/policies/".concat(policyNumber, "/documents"), "GET");
    };
    CustomerPortalServiceImpl.prototype.getPolicyDocumentsByPolicyVersionId = function (policyNumber, policyVersionId) {
        return this.doRequest("/policies/".concat(policyNumber, "/policyVersion/").concat(policyVersionId, "/documents"), "GET");
    };
    CustomerPortalServiceImpl.prototype.getPostRequestedDocumentsIds = function (policyNumber) {
        return this.doRequest("/documents/postRequest/".concat(policyNumber, "/getPostRequestedDocumentsIds"), "GET");
    };
    CustomerPortalServiceImpl.prototype.setDocumentsRequestedByPost = function (documentIds, policyNumber) {
        return this.doRequest("/documents/postRequest/setDocumentsRequestedByPost", "POST", {
            documentIds: documentIds,
            policyNumber: policyNumber,
        });
    };
    CustomerPortalServiceImpl.prototype.getQuotes = function () {
        return this.doRequest("/quotes/active", "GET");
    };
    CustomerPortalServiceImpl.prototype.getQuoteDocuments = function (quoteNumber) {
        return this.doRequest("/quotes/".concat(quoteNumber, "/documents"), "GET");
    };
    CustomerPortalServiceImpl.prototype.getDocumentWithContent = function (documentId) {
        return this.doRequest("/documents/".concat(documentId));
    };
    CustomerPortalServiceImpl.prototype.downloadDocument = function (documentId) {
        var _this = this;
        this.requestModifiers.push(new /** @class */ (function () {
            function class_1() {
            }
            class_1.prototype.modifyHttpRequest = function (request) {
                request.headers = request.headers || {};
                request.headers["Accept"] = "application/octet-stream";
                request.responseType = "blob";
                return _this.applicationGuard.modifyHttpRequest(request);
            };
            return class_1;
        }()));
        return this.doRequest("/documents/".concat(documentId, "/download"));
    };
    CustomerPortalServiceImpl.prototype.getPolicyHistory = function () {
        return this.doRequest("/policies/history", "GET");
    };
    CustomerPortalServiceImpl.prototype.getValuableItemsWithStartDates = function () {
        return this.doRequest("/onlineClaims/valuables", "GET");
    };
    CustomerPortalServiceImpl.prototype.updatePartyProperty = function (key, value) {
        return this.doRequest("/profile/property", "POST", {
            key: key,
            value: value
        });
    };
    CustomerPortalServiceImpl.prototype.getPartyPropertyByPropertyKey = function (propertyKey) {
        return this.doRequest("/profile/property/".concat(propertyKey), "GET");
    };
    CustomerPortalServiceImpl.prototype.updateMarketingPreferences = function (preferences) {
        return this.doRequest("/profile/marketing-preferences", "POST", preferences);
    };
    CustomerPortalServiceImpl.prototype.getPolicyPropertiesByPropertyKeys = function (policyNumber, propertyKeys) {
        return this.doRequest("/profile/policy/properties/".concat(policyNumber), "POST", propertyKeys);
    };
    CustomerPortalServiceImpl.prototype.getPolicyPremiumTypeByPolicyNumber = function (policyNumber) {
        return this.doRequest("/profile/policy/premiumType/".concat(policyNumber), "get");
    };
    CustomerPortalServiceImpl.prototype.getPolicyPaymentTypeByPolicyNumber = function (policyNumber) {
        return this.doRequest("/profile/policy/paymentType/".concat(policyNumber), "get");
    };
    CustomerPortalServiceImpl.prototype.isMonthlyPayerInCurrentPeriod = function (policyNumber) {
        var searchParams = new URLSearchParams();
        searchParams.append("policyNumber", policyNumber);
        return this.doRequest("/flow-policies/is-monthly-payer?".concat(searchParams.toString()), "GET");
    };
    CustomerPortalServiceImpl.prototype.updateUser = function (user) {
        return _super.prototype.getProtectedResource.call(this, {
            body: user,
            method: "POST",
            headers: this.configuration.customHeaders,
            url: "".concat(this.configuration.serviceBaseUrl, "/profile"),
        }, this.configuration.customQueryStringParameters).pipe((0, operators_1.map)(function (response) {
            return response.response;
        }), (0, operators_1.catchError)(function (err) {
            return (0, rxjs_1.of)(err);
        }));
    };
    CustomerPortalServiceImpl.prototype.validateNewCard = function (reuseCard, policyNumber) {
        if (policyNumber) {
            // annual products
            return this.doRequest("/profile/card/validate/".concat(policyNumber, "/?reuseCard=true"));
        }
        else {
            // subscription products
            return this.doRequest("/profile/card/validate/?reuseCard=".concat(reuseCard));
        }
    };
    CustomerPortalServiceImpl.prototype.verifyNewCard = function (paymentReference, reuseCard, annualCard, policyNumber) {
        if (policyNumber) {
            // annual products
            return this.doRequest("/profile/card/verify/".concat(paymentReference, "/annualCard/").concat(annualCard, "/").concat(policyNumber, "?reuseCard=").concat(reuseCard));
        }
        else {
            // subscription products
            return this.doRequest("/profile/card/verify/".concat(paymentReference, "/annualCard/").concat(annualCard, "?reuseCard=").concat(reuseCard));
        }
    };
    CustomerPortalServiceImpl.prototype.autNewCardMissedPaymentByPolicyNumber = function (product, policyNumber) {
        return this.doRequest("/profile/card/missed-payment/product/".concat(product, "/").concat(policyNumber));
    };
    CustomerPortalServiceImpl.prototype.autNewCardMissedPaymentByPolicyNumberForInvoiceId = function (product, policyNumber, invoiceId) {
        return this.doRequest("/profile/card/missed-payment/product/".concat(product, "/").concat(policyNumber, "/").concat(invoiceId));
    };
    CustomerPortalServiceImpl.prototype.autNewCardOutstandingPaymentByPolicyNumber = function (product, policyNumber) {
        return this.doRequest("/profile/card/outstanding-payment/product/".concat(product, "/").concat(policyNumber));
    };
    CustomerPortalServiceImpl.prototype.verifyNewCardAndCompleteMissedOrOutstandingPaymentByPolicyNumber = function (policyNumber, request) {
        return this.doRequest("/profile/card/verify-missed-or-outstanding-payment/".concat(policyNumber), 'POST', request);
    };
    CustomerPortalServiceImpl.prototype.completeMissedPaymentWithMainPaymentCard = function (product, policyNumber) {
        return this.doRequest("/profile/card/verify-missed-payment-existing-card/product/".concat(product, "/").concat(policyNumber), "POST");
    };
    CustomerPortalServiceImpl.prototype.completeMissedPaymentWithMainPaymentCardForInvoice = function (product, policyNumber, invoiceId) {
        return this.doRequest("/profile/card/verify-missed-payment-existing-card/product/".concat(product, "/").concat(policyNumber, "/").concat(invoiceId), "POST");
    };
    CustomerPortalServiceImpl.prototype.completeOutstandingPaymentWithMainPaymentCard = function (product, policyNumber) {
        return this.doRequest("/profile/card/verify-outstanding-payment-existing-card/product/".concat(product, "/").concat(policyNumber), "POST");
    };
    CustomerPortalServiceImpl.prototype.changeCardReuseSetting = function (cardId, reuseCard, policyNumber) {
        var searchParams = new URLSearchParams();
        searchParams.append("reuseCard", reuseCard.toString());
        if (policyNumber) {
            searchParams.append("policyNumber", policyNumber);
        }
        return this.doRequest("/profile/card/".concat(cardId, "/reuse?").concat(searchParams.toString()), "POST");
    };
    CustomerPortalServiceImpl.prototype.getUserById = function () {
        return this.doRequest("/profile/party");
    };
    CustomerPortalServiceImpl.prototype.hasIdp = function () {
        return this.doRequest("/profile/hasIdp");
    };
    CustomerPortalServiceImpl.prototype.getPaymentHistory = function () {
        return this.doRequest("/payments/history");
    };
    CustomerPortalServiceImpl.prototype.getPaymentHistoryByPolicyNumber = function (policyNumber) {
        var searchParams = new URLSearchParams();
        searchParams.append("policyNumber", policyNumber);
        return this.doRequest("/payments/history/policy_number?".concat(searchParams.toString()));
    };
    // get payment history for current period (from the latest renewal or from policy start if there is no renewal)
    CustomerPortalServiceImpl.prototype.getPaymentHistoryCurrentPeriod = function (policyNumber) {
        var searchParams = new URLSearchParams();
        searchParams.append("policyNumber", policyNumber);
        return this.doRequest("/payments/history/current_period?".concat(searchParams.toString()));
    };
    // get payment history for past period (until the latest renewal or until policy end if there is no renewal)
    CustomerPortalServiceImpl.prototype.getPaymentHistoryPastPeriod = function (policyNumber) {
        var searchParams = new URLSearchParams();
        searchParams.append("policyNumber", policyNumber);
        return this.doRequest("/payments/history/past_period?".concat(searchParams.toString()));
    };
    CustomerPortalServiceImpl.prototype.getSubscription = function () {
        return this.doRequest("/profile/subscription");
    };
    CustomerPortalServiceImpl.prototype.getAnnualPolicyInfo = function (policyNumber) {
        return this.doRequest("/profile/annualPolicyInfo/".concat(policyNumber));
    };
    CustomerPortalServiceImpl.prototype.getOptionalExtrasInformation = function (policyNumber) {
        var searchParams = new URLSearchParams();
        searchParams.append("policyNumber", policyNumber);
        return this.doRequest("/profile/optionalExtrasInformation?".concat(searchParams.toString()));
    };
    CustomerPortalServiceImpl.prototype.getCoverChanges = function (policyNumber) {
        var searchParams = new URLSearchParams();
        searchParams.append("policyNumber", policyNumber);
        return this.doRequest("/profile/coverChanges?".concat(searchParams.toString()));
    };
    CustomerPortalServiceImpl.prototype.updateValuableItem = function (request) {
        return this.doRequest("/valuables", "POST", request);
    };
    CustomerPortalServiceImpl.prototype.getValuableItemImages = function (itemId) {
        return this.doRequest("/valuables/".concat(itemId, "/images"), "GET");
    };
    CustomerPortalServiceImpl.prototype.createValuableItemImage = function (request) {
        return this.doRequest("/valuables/images", "POST", request);
    };
    CustomerPortalServiceImpl.prototype.createOnlineRentersClaimRequest = function (request) {
        return this.doRequest("/onlineClaims/renters", "POST", request);
    };
    CustomerPortalServiceImpl.prototype.createOnlineMotorClaimRequest = function (request) {
        return this.doRequest("/onlineClaims/motor", "POST", request);
    };
    CustomerPortalServiceImpl.prototype.deleteValuableItemImage = function (imageId) {
        return this.doRequest("/valuables/images/".concat(imageId), "DELETE");
    };
    CustomerPortalServiceImpl.prototype.getOnlineClaims = function () {
        return this.doRequest("/onlineClaims/claims");
    };
    CustomerPortalServiceImpl.prototype.getSettledAmountByPaymentReference = function (paymentReference) {
        return this.doRequest("/profile/payments/".concat(paymentReference, "/amount"), "GET");
    };
    CustomerPortalServiceImpl.prototype.getInstalmentsInfo = function (policyVersionId) {
        return this.doRequest("/profile/payments/".concat(policyVersionId, "/instalmentsInfo"));
    };
    CustomerPortalServiceImpl.prototype.getInstalmentsInfoByAgreementNumber = function (agreementNumber) {
        return this.doRequest("/payment/".concat(agreementNumber, "/instalmentsInfo"));
    };
    CustomerPortalServiceImpl.prototype.getMissedPaymentInfo = function (policyVersionId) {
        return this.doRequest("/profile/payments/".concat(policyVersionId, "/missedPaymentInfo"));
    };
    CustomerPortalServiceImpl.prototype.getCombinedInstalmentsInfo = function (agreementVersionIds) {
        var queryString = "agreementVersionIds=";
        for (var i = 0; i < agreementVersionIds.length; i++) {
            queryString += agreementVersionIds[i];
            if (i < agreementVersionIds.length - 1) {
                queryString += ",";
            }
        }
        return this.doRequest("/profile/payments/instalmentsInfo?".concat(queryString), "GET");
    };
    CustomerPortalServiceImpl.prototype.getCombinedInstalmentsInfoByPolicyNumber = function (policyNumber) {
        var queryString = "policyNumber=" + policyNumber;
        return this.doRequest("/profile/payments/instalmentsInfoByAgreementNumber?".concat(queryString), "GET");
    };
    CustomerPortalServiceImpl.prototype.getEmailHistory = function () {
        return this.doRequest("/profile/emails", "GET");
    };
    CustomerPortalServiceImpl.prototype.getWolfEmailHistory = function () {
        return this.doRequest("/profile/emails/wolf", "GET");
    };
    CustomerPortalServiceImpl.prototype.existingCardPayment = function (request) {
        return this.doRequest("/payment/existing-card-payment", "POST", request);
    };
    CustomerPortalServiceImpl.prototype.getPaymentAmount = function (invoiceType) {
        return this.doRequest("/payment/amount?invoiceType=".concat(invoiceType));
    };
    CustomerPortalServiceImpl.prototype.newCardPaymentStart = function (request, policyNumber) {
        return this.doRequest("/payment/new-card-payment-start/".concat(policyNumber), "POST", request);
    };
    CustomerPortalServiceImpl.prototype.newCardPaymentVerify = function (request, paymentReference) {
        return this.doRequest("/payment/new-card-payment-verify/".concat(paymentReference), "POST", request);
    };
    CustomerPortalServiceImpl.prototype.constructTrustPilotReviewUrlForAnnualMotor = function (referenceNumber) {
        return this.doRequest("/trustpilot/construct-review-url-annual-motor", "POST", { referenceNumber: referenceNumber });
    };
    CustomerPortalServiceImpl.prototype.constructTrustPilotReviewUrlForAnnualHome = function (referenceNumber) {
        return this.doRequest("/trustpilot/construct-review-url-annual-home", "POST", { referenceNumber: referenceNumber });
    };
    CustomerPortalServiceImpl.prototype.createReviewRequest = function (policyNumber) {
        return this.doRequest("/trustpilot/create-review", "POST", { policyNumber: policyNumber });
    };
    CustomerPortalServiceImpl.prototype.putOnHoldReviewRequest = function (referenceNumber) {
        return this.doRequest("/trustpilot/hold-review", "POST", { referenceNumber: referenceNumber });
    };
    CustomerPortalServiceImpl.prototype.activateReviewRequests = function (policyNumber) {
        return this.doRequest("/trustpilot/activate-review/".concat(policyNumber), "POST", {});
    };
    CustomerPortalServiceImpl.prototype.increaseReviewRequestAttemptCount = function (referenceNumber) {
        return this.doRequest("/trustpilot/inc-attempt-count", "POST", { referenceNumber: referenceNumber });
    };
    CustomerPortalServiceImpl.prototype.getReviewRequest = function (policyNumber) {
        return this.doRequest("/trustpilot/get-review/".concat(policyNumber), "GET");
    };
    CustomerPortalServiceImpl.prototype.storePolicyAutomaticRenewalCancellationReason = function (agreementNumber, cancellationReason) {
        return this.doRequest("/renewals/store-automatic-policy-renewal-cancellation-reason/".concat(agreementNumber), 'POST', cancellationReason);
    };
    CustomerPortalServiceImpl.prototype.storePolicyAutomaticRenewalFlag = function (agreementNumber, value) {
        return this.doRequest("/renewals/store-automatic-policy-renewal-flag/".concat(agreementNumber), 'POST', value.toString());
    };
    CustomerPortalServiceImpl.prototype.storePolicyPerformRenewalFlag = function (agreementNumber, value) {
        return this.doRequest("/renewals/store-policy-perform-renewal-flag/".concat(agreementNumber), 'POST', value.toString());
    };
    CustomerPortalServiceImpl.prototype.storePaymentDay = function (agreementNumber, value) {
        return this.doRequest("/profile/policy/".concat(agreementNumber, "/update-payment-day"), 'POST', value.toString());
    };
    CustomerPortalServiceImpl.prototype.storeAnnualToMonthlyPaymentDay = function (agreementNumber, value) {
        return this.doRequest("/profile/policy/".concat(agreementNumber, "/update-annual-to-monthly-payment-day"), 'POST', value.toString());
    };
    CustomerPortalServiceImpl.prototype.getRenewalProposal = function (agreementNumber) {
        return this.doRequest("/renewals/proposal/".concat(agreementNumber), "GET");
    };
    CustomerPortalServiceImpl.prototype.payOffBalance = function (request, agreementNumber) {
        return this.doRequest("/payment/".concat(agreementNumber, "/pay-off-balance"), "POST", request);
    };
    CustomerPortalServiceImpl.prototype.payOffBalanceWithNewCard = function (request, agreementNumber, paymentReference, reuseCard) {
        return this.doRequest("/payment/".concat(agreementNumber, "/pay-off-balance-new-card/").concat(paymentReference, "?reuseCard=").concat(reuseCard), "POST", request);
    };
    CustomerPortalServiceImpl.prototype.doRequest = function (urlAppend, method, body) {
        var _this_1 = this;
        return _super.prototype.getProtectedResource.call(this, {
            body: body,
            method: method || "GET",
            headers: this.configuration.customHeaders,
            url: "".concat(this.configuration.serviceBaseUrl).concat(urlAppend),
        }, this.configuration.customQueryStringParameters).pipe((0, operators_1.map)(function (response) {
            return response.response;
        }), (0, operators_1.catchError)(function (err) {
            _this_1.notificationService.push({
                level: "ERROR",
                message: "We are experiencing some technical issues, please come back later"
            });
            return (0, rxjs_1.throwError)(err);
        }));
    };
    CustomerPortalServiceImpl.prototype.getPolicyHistoryAfterRenewal = function () {
        return this.doRequest("/flow-policies/policy-history-after-renewal", "GET");
    };
    CustomerPortalServiceImpl.prototype.getPolicyPropertyByPropertyKey = function (policyNumber, propertyKey) {
        return this.doRequest("/profile/policy_property/".concat(policyNumber, "/").concat(propertyKey), "GET");
    };
    CustomerPortalServiceImpl.prototype.getDocumentByNameAndPolicyNumber = function (policyNumber, documentName) {
        return this.doRequest("/documents/".concat(policyNumber, "/").concat(documentName, "/"), "GET");
    };
    CustomerPortalServiceImpl.prototype.getMainPaymentCard = function (policyNumber) {
        return this.doRequest("/profile/card/main/".concat(policyNumber), 'GET');
    };
    CustomerPortalServiceImpl.prototype.updateDirectDebit = function (policyNumber, request) {
        return _super.prototype.getProtectedResource.call(this, {
            body: request,
            method: "POST",
            headers: this.configuration.customHeaders,
            url: "".concat(this.configuration.serviceBaseUrl, "/profile/policy/").concat(policyNumber, "/edit-direct-debit"),
        }, this.configuration.customQueryStringParameters).pipe((0, operators_1.map)(function (response) {
            return response.response;
        }), (0, operators_1.catchError)(function (err) {
            return (0, rxjs_1.of)(err);
        }));
    };
    CustomerPortalServiceImpl.prototype.getInstalmentInfoPreview = function (policyNumber, paymentDay) {
        return this.doRequest("/profile/policy/".concat(policyNumber, "/preview-payment-day/").concat(paymentDay.toString()), 'GET');
    };
    CustomerPortalServiceImpl.prototype.getAvailablePaymentDays = function (policyNumber) {
        return this.doRequest("/profile/policy/".concat(policyNumber, "/available-payment-days"), 'GET');
    };
    CustomerPortalServiceImpl.prototype.isApplicableForPaymentDayChange = function (policyNumber) {
        return this.doRequest("/profile/policy/".concat(policyNumber, "/payment-day-change-allowed"), 'GET');
    };
    __decorate([
        (0, Cache_1.CacheObservable)(true),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "getProfile", null);
    __decorate([
        (0, Cache_1.CacheObservable)(true),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Number, Boolean]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "getPolicies", null);
    __decorate([
        (0, Cache_1.CacheObservable)(true),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "getExpiredPolicies", null);
    __decorate([
        (0, Cache_1.CacheObservable)(true),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "getMinOrMaxFutureMtaDate", null);
    __decorate([
        (0, Cache_1.CacheObservable)(true),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "mtaIsPresentForMultiplePolicies", null);
    __decorate([
        (0, Cache_1.CacheObservable)(true),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "accountHasPolicyWith24hOldMTA", null);
    __decorate([
        (0, Cache_1.CacheObservable)(true),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "policyHas24hOldMTA", null);
    __decorate([
        (0, Cache_1.CacheObservable)(true),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "getFutureMtaCount", null);
    __decorate([
        (0, Cache_1.CacheObservable)(true),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "getPoliciesByPolicyVersionId", null);
    __decorate([
        (0, Cache_1.CacheObservable)(true),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "getPolicy", null);
    __decorate([
        (0, Cache_1.CacheObservable)(true),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "getAllDocuments", null);
    __decorate([
        (0, Cache_1.CacheObservable)(true),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "getPolicyDocuments", null);
    __decorate([
        (0, Cache_1.CacheObservable)(true),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Number]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "getPolicyDocumentsByPolicyVersionId", null);
    __decorate([
        (0, Cache_1.CacheObservable)(true),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "getQuotes", null);
    __decorate([
        (0, Cache_1.CacheObservable)(true),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "getQuoteDocuments", null);
    __decorate([
        (0, Cache_1.CacheObservable)(true),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "getDocumentWithContent", null);
    __decorate([
        (0, Cache_1.CacheObservable)(true),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "getPolicyHistory", null);
    __decorate([
        (0, Cache_1.CacheObservable)(true),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "getValuableItemsWithStartDates", null);
    __decorate([
        (0, Cache_1.ClearCache)("getProfile"),
        (0, Cache_1.ClearCache)("getUserById"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "updatePartyProperty", null);
    __decorate([
        (0, Cache_1.ClearCache)("getProfile"),
        (0, Cache_1.ClearCache)("getUserById"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "getPartyPropertyByPropertyKey", null);
    __decorate([
        (0, Cache_1.ClearCache)("getProfile"),
        (0, Cache_1.ClearCache)("getUserById"),
        (0, Cache_1.ClearCache)("getPolicy"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [model_1.FalconUser]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "updateUser", null);
    __decorate([
        (0, Cache_1.ClearCache)("getProfile"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean, String]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "validateNewCard", null);
    __decorate([
        (0, Cache_1.ClearCache)("getProfile"),
        (0, Cache_1.ClearCache)("getPolicyPropertyByPropertyKey"),
        (0, Cache_1.ClearCache)("getAnnualPolicyInfo"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Boolean, Boolean, String]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "verifyNewCard", null);
    __decorate([
        (0, Cache_1.ClearCache)("getProfile"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "autNewCardMissedPaymentByPolicyNumber", null);
    __decorate([
        (0, Cache_1.ClearCache)("getProfile"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String, String]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "autNewCardMissedPaymentByPolicyNumberForInvoiceId", null);
    __decorate([
        (0, Cache_1.ClearCache)("getProfile"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "autNewCardOutstandingPaymentByPolicyNumber", null);
    __decorate([
        (0, Cache_1.ClearCache)("getProfile"),
        (0, Cache_1.ClearCache)("getSubscription"),
        (0, Cache_1.ClearCache)("getPolicyDocuments"),
        (0, Cache_1.ClearCache)("getPaymentHistory"),
        (0, Cache_1.ClearCache)("getAnnualPolicyInfo"),
        (0, Cache_1.ClearCache)("getPaymentHistoryByPolicyNumber"),
        (0, Cache_1.ClearCache)("getPolicy"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, model_1.MissedPayment]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "verifyNewCardAndCompleteMissedOrOutstandingPaymentByPolicyNumber", null);
    __decorate([
        (0, Cache_1.ClearCache)("getProfile"),
        (0, Cache_1.ClearCache)("getSubscription"),
        (0, Cache_1.ClearCache)("getPolicyDocuments"),
        (0, Cache_1.ClearCache)("getPaymentHistory"),
        (0, Cache_1.ClearCache)("getAnnualPolicyInfo"),
        (0, Cache_1.ClearCache)("getPaymentHistoryByPolicyNumber"),
        (0, Cache_1.ClearCache)("getPolicy"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "completeMissedPaymentWithMainPaymentCard", null);
    __decorate([
        (0, Cache_1.ClearCache)("getProfile"),
        (0, Cache_1.ClearCache)("getSubscription"),
        (0, Cache_1.ClearCache)("getPolicyDocuments"),
        (0, Cache_1.ClearCache)("getPaymentHistory"),
        (0, Cache_1.ClearCache)("getAnnualPolicyInfo"),
        (0, Cache_1.ClearCache)("getPaymentHistoryByPolicyNumber"),
        (0, Cache_1.ClearCache)("getPolicy"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String, String]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "completeMissedPaymentWithMainPaymentCardForInvoice", null);
    __decorate([
        (0, Cache_1.ClearCache)("getProfile"),
        (0, Cache_1.ClearCache)("getSubscription"),
        (0, Cache_1.ClearCache)("getPolicyDocuments"),
        (0, Cache_1.ClearCache)("getPaymentHistory"),
        (0, Cache_1.ClearCache)("getAnnualPolicyInfo"),
        (0, Cache_1.ClearCache)("getPaymentHistoryByPolicyNumber"),
        (0, Cache_1.ClearCache)("getPolicy"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "completeOutstandingPaymentWithMainPaymentCard", null);
    __decorate([
        (0, Cache_1.ClearCache)("getProfile"),
        (0, Cache_1.ClearCache)("getAnnualPolicyInfo"),
        (0, Cache_1.ClearCache)("getPolicyPropertyByPropertyKey"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Boolean, String]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "changeCardReuseSetting", null);
    __decorate([
        (0, Cache_1.CacheObservable)(true),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "getSubscription", null);
    __decorate([
        (0, Cache_1.CacheObservable)(true),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "getAnnualPolicyInfo", null);
    __decorate([
        (0, Cache_1.CacheObservable)(true),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "getOptionalExtrasInformation", null);
    __decorate([
        (0, Cache_1.CacheObservable)(true),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "getCoverChanges", null);
    __decorate([
        (0, Cache_1.ClearCache)("getPolicies"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [model_1.ValuableItemRequest]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "updateValuableItem", null);
    __decorate([
        (0, Cache_1.CacheObservable)(true),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "getValuableItemImages", null);
    __decorate([
        (0, Cache_1.ClearCache)("getValuableItemImages"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [model_1.ImageRequest]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "createValuableItemImage", null);
    __decorate([
        (0, Cache_1.ClearCache)("getValuableItemImages"),
        (0, Cache_1.ClearCache)("getProfile"),
        (0, Cache_1.ClearCache)("getUserById"),
        (0, Cache_1.ClearCache)("getPaymentHistory"),
        (0, Cache_1.ClearCache)("getOnlineClaims"),
        (0, Cache_1.ClearCache)("getPaymentHistoryByPolicyNumber"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [model_1.OnlineRentersClaimRequest]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "createOnlineRentersClaimRequest", null);
    __decorate([
        (0, Cache_1.ClearCache)("getValuableItemImages"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "deleteValuableItemImage", null);
    __decorate([
        (0, Cache_1.CacheObservable)(true),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "getOnlineClaims", null);
    __decorate([
        (0, Cache_1.ClearCache)("getAnnualPolicyInfo"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "getSettledAmountByPaymentReference", null);
    __decorate([
        (0, Cache_1.CacheObservable)(true),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "getInstalmentsInfoByAgreementNumber", null);
    __decorate([
        (0, Cache_1.CacheObservable)(true),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "getEmailHistory", null);
    __decorate([
        (0, Cache_1.CacheObservable)(true),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "getWolfEmailHistory", null);
    __decorate([
        (0, Cache_1.ClearCache)("getPaymentHistory"),
        (0, Cache_1.ClearCache)("getAnnualPolicyInfo"),
        (0, Cache_1.ClearCache)("getPaymentHistoryByPolicyNumber"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [model_1.FalconPaymentRequest]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "existingCardPayment", null);
    __decorate([
        (0, Cache_1.ClearCache)("getPaymentHistory"),
        (0, Cache_1.ClearCache)("getAnnualPolicyInfo"),
        (0, Cache_1.ClearCache)("getPaymentHistoryByPolicyNumber"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [model_1.FalconPaymentRequest, String]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "newCardPaymentVerify", null);
    __decorate([
        (0, Cache_1.ClearCache)("getPolicies"),
        (0, Cache_1.ClearCache)("getRenewalProposal"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, model_1.RenewalCancellationReasonRequest]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "storePolicyAutomaticRenewalCancellationReason", null);
    __decorate([
        (0, Cache_1.ClearCache)("getRenewalProposal"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Number]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "storeAnnualToMonthlyPaymentDay", null);
    __decorate([
        (0, Cache_1.CacheObservable)(true),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "getRenewalProposal", null);
    __decorate([
        (0, Cache_1.ClearCache)("getInstalmentsInfoByAgreementNumber"),
        (0, Cache_1.ClearCache)("getPaymentHistory"),
        (0, Cache_1.ClearCache)("getPaymentHistoryByPolicyNumber"),
        (0, Cache_1.ClearCache)("getPaymentHistoryCurrentPeriod"),
        (0, Cache_1.ClearCache)("getPaymentHistoryPastPeriod"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [model_1.FalconPaymentRequest, String]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "payOffBalance", null);
    __decorate([
        (0, Cache_1.ClearCache)("getInstalmentsInfoByAgreementNumber"),
        (0, Cache_1.ClearCache)("getPaymentHistory"),
        (0, Cache_1.ClearCache)("getPaymentHistoryByPolicyNumber"),
        (0, Cache_1.ClearCache)("getPaymentHistoryCurrentPeriod"),
        (0, Cache_1.ClearCache)("getPaymentHistoryPastPeriod"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [model_1.FalconPaymentRequest, String, String, Boolean]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "payOffBalanceWithNewCard", null);
    __decorate([
        (0, Cache_1.CacheObservable)(true),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "getPolicyPropertyByPropertyKey", null);
    __decorate([
        (0, Cache_1.CacheObservable)(true),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], CustomerPortalServiceImpl.prototype, "getDocumentByNameAndPolicyNumber", null);
    CustomerPortalServiceImpl = __decorate([
        (0, core_1.injectable)(),
        __param(0, (0, core_1.inject)(Types_1.Types.CustomerPortalServiceConfig)),
        __param(1, (0, core_1.inject)(Types_1.Types.NotificationService)),
        __metadata("design:paramtypes", [Object, Object])
    ], CustomerPortalServiceImpl);
    return CustomerPortalServiceImpl;
}(core_1.RestService));
//# sourceMappingURL=CustomerPortalServiceImpl.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-services/dist/services/impl/CustomerPortalServiceImpl.js
// module id = 2425
// module chunks = 0